__webpack_require__.p = "https://oss-assets.amberstudent.cn/amber-user-website/VP1-8.54.24-c11e-amber-user-website-prod-hk-1883/assets/";